export default __webpack_public_path__ + "static/media/php.f7c40755.jpg";